export const SET_PRODUCT = 'setProduct';
export const SET_PRODUCTS = 'setProducts';
export const PRODUCT_RESET_STATE = 'productResetState';
export const SET_CATEGORIES = 'setCategories';
export const SET_PACKAGES = 'setPackages';
export const SET_UNITS = 'setUnits';
export const SET_CLASSES = 'setClasses';
export const SET_BRANDS = 'setBrands';
export const SET_PRODUCTS_SIMPLE = 'setProductsSimple';
export const FILTER_PRODUCTS_SIMPLE = 'filterProductsSimple'
export const SET_PRODUCT_PAGINATION = 'setProductPagination'
export const SET_PRODUCT_ACTIVE = 'setProductActive'